import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import {  ActivityIndicator, ScrollView } from "react-native";
import {Minus,Plus,ClockCounterClockwise,FunnelSimple} from '@sharedComponents/Icons/Icons';
import { useEffect, useState } from "react";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import PleadegedAssetInfo from "../PleadgeMF/PleadegedAssetInfo"
import ROUTE from "@app/navigationApp/routes";
import { addCommasToNumber } from "@app/utils";
import { updateAssetData } from "@app/store/slices/authSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import FilterComponent from "../RemovePledge/FilterComponent";
import Button from "@app/sharedComponents/Button/Button";
import { Warning,Info } from '@app/sharedComponents/Icons/Icons';
import { formatIndianCurrency } from "@app/utils/utility";





const ViewDetails = ({navigation}) =>{
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const isLoanExpired = useAppSelector((state)=>state.commonReducer.isLoanExpired)
    const [assetList,setAssetList] = useState([]);
    const [isIncreaseLimitNotAllowed,setIsIncreaseLimitNotAllowed] = useState(false)
    const [isUnpledgeRequestInProgress,setIsUnpledgeRequestInProgress] = useState(false)
    const [revocationRequestDetailsList,setRevocationRequestList] = useState([])
    const [isDecreaseLimitAllowed,setIsDecreaseLimitAllowed] = useState(false)
    const [isUnpledgeNotAllowed,setIsUnpledgeNotAllowed] = useState(false)
    const [filtersSections, setFiltersSections] = useState([]);
    const [manageLimitConfig,setManageLimitConfig] = useState({})
    const [activeFilter, setActiveFilter] = useState('');
    const [isAssetListLoading, setIsAssetListLoading] = useState(true);
    const [checkedFilters, setCheckedFilters] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [isProblemAtLenderEnd, setisProblemAtLenderEnd] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [filteredAssetList, setFilteredAssetList] = useState([]);
    const [isListLoading,setIsListLoading] = useState(false)
    const [showFilter,setShowFilter] = useState(false)
    const eligibleFilters = [];


    const onFilterCheckBoxPressed = (filter) => {{
        const index = checkedFilters.indexOf(filter);
        if (index > -1) {
            checkedFilters.splice(index, 1);
        } else {
            checkedFilters.push(filter);
        }
        setCheckedFilters([...checkedFilters]);
    }}

    const onEditAmountPressed = (asset) => {{
        console.log('asset',asset)
    }}

    const onApplyFilterPressed = () => {{
        if(checkedFilters.length !== 0){
            const filteredAssets = assetList.filter(
                asset => checkedFilters.some(checked => checked.isinCode === asset.isinCode)
              );
        
              console.log("FILTERED LIST",filteredAssets)

              setFilteredAssetList(filteredAssets)
              
              
              
            }     
            else {
                setFilteredAssetList(assetList)
            }
            setShowFilter(false)   
    }}

    const calculateSumOfAssetPledgedValue = (assetList) => {{
        // do nothing
    }}

    const renderEditAmount = () => {{
        // do nothing , unused funciton
    }}

    const onCheckBoxPressed = (item) => {{
        // do nothing , unused funciton
    }}

    

    const dispatch = useAppDispatch()
    const fetchpleadedList = ()=>{
        const url = endpoints.pleadgeList + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            console.log('pledgedMFList',res.data)
            dispatch(updateAssetData(res.data))
            setAssetList(res?.data)
            setFilteredAssetList(res?.data)
            segregateFilters(res?.data)
        }).catch((err)=>{
            console.log('pledgedMFList',err)
        })
    }
    useEffect(()=>{
        setIsListLoading(true)
        fetchpleadedList()
     
    },[])

    const getManageLimitConfig = () => {
        const url = endpoints.manageLimitConfig + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
       

           setManageLimitConfig(res?.data)
           setIsListLoading(false)
        //    navigation.navigate("MF_FETCH")


      
        }).catch((err)=>{
          console.log('newApplication',err) 
        }).finally(()=>{
            setIsListLoading(false)
        })
    
    }


 


const fetchNewApplication = ()=>{
    const payload =    {
      creditApplicationType: "CREDIT_MODIFICATION_AGAINST_SECURITIES",
  }
  
    const url = endpoints.enhanceLimit + userDetails?.linkedBorrowerAccounts[0].accountId
    axios.post(url,payload).then((res)=>{
      const applicationId = res?.data?.applicationId
       AsyncStorage.setItem("application_id", applicationId)
       AsyncStorage.setItem("is_from_enhance_limit", "true")
       AsyncStorage.setItem("currentStepId", res?.data?.currentStepId)
       navigation.navigate("MF_FETCH")
  
    }).catch((err)=>{
      console.log('newApplication',err) 
    }).finally(()=>{
    })
  }
  
    const pleadeMore = ()=>{
        console.log("manageLimitConfig",manageLimitConfig)
        if(manageLimitConfig?.increaseLimitAllowed){
      fetchNewApplication()
    }
    else {

        setIsIncreaseLimitNotAllowed(true)     
    }
    }

    const removePledge = ()=>{

        // navigation.navigate(ROUTE.UNPLEDGE_INSTRUCTIONS)
       if(isLoading)
       return 
        if(revocationRequestDetailsList.length !== 0){
            setIsUnpledgeRequestInProgress(true)
        }
        else if(manageLimitConfig?.decreaseLimitAllowed){
          fetchTotalOutstanding()
        }
        else {
            setIsUnpledgeNotAllowed(true)
        }
    }
    //


    const segregateFilters = (fundList) => {
        fundList.map((item) => {
            if (
                eligibleFilters.includes(item.assetSubType)
            ) {
                console.log("INSIDE IF",item.assetSubType)
                // Do nothing basically
            } 
            else { 
                console.log("INSIDE ELSE",item.assetSubType) 
                eligibleFilters.push(item.assetSubType);
            }
        });


        setFiltersSections(eligibleFilters);

        console.log("eligibleFilters",eligibleFilters)

        setActiveFilter(eligibleFilters[0]);

        setIsAssetListLoading(false)

                
}


const renderErrorAtLenderEnd =() => {
    return(
        <BottomSheetContainer
        isVisible={isProblemAtLenderEnd}
        close={() =>{                   
            setisProblemAtLenderEnd(false)
        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <Info  color="grey" weight ={"fill"} size={48} />

                <ThemedText marginTop="lg" variant="h5s">Service temporarily unavailable</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r">{"We’re experiencing a temporary issue with our lending partner. Please try again after sometime"}</ThemedText>
                 </ThemedView>

                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   
                  setisProblemAtLenderEnd(false)

                }} label={"Ok, got it!"}/>
                    


        </ThemedView>
    
    </BottomSheetContainer>
    )

}

  const renderEnhanceLimitBlockCard = () => {
    return(
        <BottomSheetContainer
        isVisible={isIncreaseLimitNotAllowed || isUnpledgeNotAllowed}
        close={() =>{ setIsIncreaseLimitNotAllowed(false)
        setIsUnpledgeNotAllowed(false)
        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <Info  color="grey" weight ={"fill"} size={48} />

                <ThemedText marginTop="lg" variant="h5s">Account set up-in progress</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r">{isUnpledgeNotAllowed? "You’ll be able to remove pledge from funds as soon as the account set up is complete. Please try again after sometime" : "You’ll be able to pledge more funds as soon as the account set up is complete. Please try again after sometime"}</ThemedText>
                 </ThemedView>

                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   
                   setIsIncreaseLimitNotAllowed(false)
                   setIsUnpledgeNotAllowed(false)

                }} label={"Ok, got it!"}/>
                    


        </ThemedView>
    
    </BottomSheetContainer>
    )
  }

  const renderUnpledgeRequestInProgressCard = () => {
    return(
        <BottomSheetContainer
        isVisible={isUnpledgeRequestInProgress}
        close={() => setIsUnpledgeRequestInProgress(false)}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <Info  color="grey" weight ={"fill"} size={48} />

                <ThemedText marginTop="lg" variant="h5s">Unpledge Request in progress</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r" textAlign="center">{"We’re processing your previous request to unpledge funds. You cannot place a new request until then."}</ThemedText>
                 </ThemedView>
                <Button overRideStyle={{marginTop : 24}} type="OUTLINED" handlePress={()=> {
                   setIsUnpledgeRequestInProgress(false)
                   navigation.navigate(ROUTE.PLEDGE_HISTORY)
                }} label={"View existing request"}/>
                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   setIsUnpledgeRequestInProgress(false)
                }} label={"Ok, got it!"}/>
                 

        </ThemedView>
    
    </BottomSheetContainer>
    )
  }

    const  renderFilter = () =>{
          return(
        <BottomSheetContainer
        isVisible={showFilter}
        close={()=> {
             setShowFilter(false)
        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    >
     
        <FilterComponent
          {...{
            filtersSections,
            assetList,
            setFilteredList,
            filteredList ,
            onFilterCheckBoxPressed,
            checkedFilters,
            onEditAmountPressed,
            setCheckedFilters,
            setFilteredAssetList,
            onApplyFilterPressed,
            selectedFilter: activeFilter,
          }}
        />
    </BottomSheetContainer>
        )
    }

      return(
        <>
        <PageHeaders pageName="PleadgeMF" label={"Pledged mutual funds"}  navigation={navigation} />
        <ScrollView style={{backgroundColor : themeColorSet['bg-surface-page'],flex:1}}  >
        <ThemedView mx="lg" my="md" px="lg" py="md" backgroundColor="bg-fill-primary" borderRadius="md" >
            <ThemedText variant="b3r" color="text-primary">Mutual fund value</ThemedText>
        <ThemedText variant="b3r" color="text-primary">{`₹${formatIndianCurrency(userDetails?.linkedCredits[0]?.totalValueOfAssetsPledged)}`}</ThemedText>
        </ThemedView>

        <ThemedView p="lg" pb="2xl" backgroundColor="bg-surface-primary" borderTopWidth={1} borderColor="border-primary">
            <ThemedText variant="b3s" color="text-primary" mb="lg">Pledged funds</ThemedText>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="lg">
                <ThemedText variant="b3r" color="text-primary">{`${assetList.length} MFs`  }</ThemedText>
             
            </ThemedView>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                <ThemedText variant="b4r" color="text-secondary">Mutual fund</ThemedText>
                <ThemedText variant="b4r" color="text-secondary">Fund value</ThemedText>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-primary" width="100%" my="sm" />
            {
              false ? <>
                 <ActivityIndicator size={"large"}></ActivityIndicator>
              </> :   filteredAssetList.map((assetList,index)=><PleadegedAssetInfo key={index} asset={assetList}/>)
            }
        </ThemedView>

        {renderFilter()}
         {renderEnhanceLimitBlockCard()}
         {renderUnpledgeRequestInProgressCard()}
         {renderErrorAtLenderEnd()}
        </ScrollView>
        </>
    )
}

export default ViewDetails;